<script>
  export let title = ''
  export let helpText = ''
</script>

<div class="card-item uk-card uk-card-body uk-card-small">
  {#if title}
    <div>
      <h3 class="font-size-18 font-bold">{title} <span>{helpText}</span></h3>
    </div>
  {/if}
  <slot />
</div>

<style>
  .card-item {
    border: 1px solid #f0f0f0;
  }
  h3 {
    font-weight: 700;
    margin: 0;
  }
  span {
    font: 12px;
    color: #999999;
    margin-left: 10px;
    font-weight: normal;
  }
</style>
